var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-header',{staticClass:"bg-theme"},[_c('div',{staticClass:"h-full flex items-center justify-between"},[_c('img',{attrs:{"src":"/img/dygc-logo.png","width":"108px","alt":"logo"}}),_vm._t("right-button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }